import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './en-US.json'
import zhCN from './zh-CN.json'
import zhTW from './zh-TW.json'
import store from '../../store'

export const resources = {
  'zh-CN': {
    ...zhCN
  },
  'zh-TW': {
    ...zhTW
  },
  'en-US': {
    ...enUS
  },
}

export type Languges = keyof typeof resources
export type Namespace = keyof typeof resources[Languges]
// export type resourcesType = typeof resources[Languges][Namespace]

export const initI18n = (res: typeof resources) => {
  console.log("initI18n", res)
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: res,
      ns: ['common'],
      defaultNS: 'common',
      fallbackLng: 'zh-CN',
      lng: "zh-CN",
      // fallbackLng: 'en-US',
      // lng: 'en-US',

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    })

  setTimeout(() => {
    const { config } = store.getState()
    config.lang && i18n.changeLanguage(config.lang)
  });
}
initI18n(resources)

export default i18n
